import axios from 'axios';

const api = axios.create({
  // baseURL: "http://192.168.29.201:5000/api/admin"
  // baseURL: "http://192.168.0.198:5000/api/admin"
   baseURL: "https://admin.roamjssln.com/api/admin"
  // baseURL: "https://development.roamjssln.com/api/admin"
});

export default api;